export function urlForRetro(id: string, secret?: string) {
  if (secret) return `/board/${id}/${secret}`;
  return `/board/${id}`;
}
